export default {
    data () {
        return {
            page: 'index'
        }
    },

    methods: {
        goToPage (page) {
            if (this.goingToPage) {
                this.goingToPage(page)
            }

            this.page = page
        },

        isPage (page) {
            return this.page === page
        },

        reset () {
            this.page = 'index'
        }
    }
}
